import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const expedientsStartRequest = () => {
  return {
    type: 'EXPEDIENTS_START_REQUEST'
  };
};

export const expedientsEndRequest = () => {
  return {
    type: 'EXPEDIENTS_END_REQUEST'
  };
};

export const getAllExpedientsSuccess = ({ data }) => {
  return {
    type: 'EXPEDIENTS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllExpedientsError = error => {
  return {
    type: 'EXPEDIENTS_GET_ALL_ERROR',
    payload: error
  };
};

export const addExpedientsSuccess = ({ data }) => {
  return {
    type: 'EXPEDIENTS_ADD_SUCCESS',
    payload: data
  };
};

export const addExpedientsError = error => {
  return {
    type: 'EXPEDIENTS_ADD_ERROR',
    payload: error
  };
};

export const editExpedientsSuccess = ({ data }) => {
  return {
    type: 'EXPEDIENTS_EDIT_SUCCESS',
    payload: data
  };
};

export const editExpedientsError = error => {
  return {
    type: 'EXPEDIENTS_EDIT_ERROR',
    payload: error
  };
};

export const removeExpedientsSuccess = id => {
  return {
    type: 'EXPEDIENTS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeExpedientsError = error => {
  return {
    type: 'EXPEDIENTS_REMOVE_ERROR',
    payload: error
  };
};

export const expedientsModifyStore = ({ data }) => {
  return {
    type: 'EXPEDIENTS_MODIFY_STORE',
    payload: data
  };
};

export const addExpedients = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(expedientsStartRequest());
      const response = await api().post('/api/expedients', data);
      dispatch(addExpedientsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'expedients',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addExpedientsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(expedientsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllExpedients = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(expedientsStartRequest());
      const response = await api().get('/api/expedients', { params });
      dispatch(getAllExpedientsSuccess(response));
    } catch (err) {
      dispatch(getAllExpedientsError(err));
    } finally {
      dispatch(expedientsEndRequest());
    }
  };
};

export const editExpedients = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(expedientsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(expedientsStartRequest());
      const id = data._id;
      const response = await api().put('/api/expedients/' + id, data);
      dispatch(editExpedientsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'expedients',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/expedients'));
      }
    } catch (err) {
      dispatch(editExpedientsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeExpedients = id => {
  return async dispatch => {
    try {
      dispatch(expedientsStartRequest());
      await api().delete('/api/expedients/' + id);
      dispatch(removeExpedientsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'expedients',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Expediente removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeExpedientsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover expediente.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(expedientsEndRequest());
    }
  };
};
